$('.content a').each(function(){
        if($(this).attr('href')!=='#misja'){
            $(this).attr('target','_blank');
        }
});